import common from './items/common.json'
import validation from './items/validation.json'
import pages from './items/pages.json'
import labels from './items/labels.json'
import medicalRecordFeature from './items/medicalRecordFeature.json'

const translations = {
  common,
  validation,
  pages,
  labels,
  medicalRecordFeature,
}
export default translations
